export const dashboardPageUrlRegExp = /\/dashboard\.jsp/i;

export const myProfilePageUrlRegExp = /\/myProfile\.jsp/i;

export const myAccountMyListPageUrlRegExp = /\/myAccountMyList\.jsp/i;

export const myAccountAddressBookPageUrlRegExp = /\/MyAccountAddressBook\.jsp/i;

export const myAccountPaymentMethodPageUrlRegExp = /\/myAccountPaymentMethod\.jsp/i;

export const myAccountAddTaxIDPageUrlRegExp = /\/myAccount(Add)?TaxID\.jsp/i;

export const myAccountVatIdPageUrlRegExp = /\/myAccountVatId\.jsp/i;

export const myAccountOrderHistoryPageUrlRegExp = /\/myAccountOrderHistory\.jsp/i;

export const myRegisteredProductsPageUrlRegExp = /\/myRegisteredProducts\.jsp/i;

export const myPartnerPortalPageUrlRegExp = /\/partners\/Menu\//i;
export const successVatId = /update=success/i;
export const successTaxId = /add=success/i;
